var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerSpaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 96.96",
    style: {
      enableBackground: "new 0 0 122.88 96.96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.88,39.15c-2.84,32.48-23.77,52.06-58.93,57.81C65.11,56.71,91.95,45.24,122.88,39.15L122.88,39.15z M37.86,44.69C40.17,26.15,43.28,12.14,61.72,0c13.2,10.44,20.17,16.71,23.43,44.9c-9.72,2.33-18.39,12.82-23.54,28.85 C56.64,57.98,48.64,48.47,37.86,44.69L37.86,44.69z M91.73,42.62l-3.55-16.66c5.99-5.14,16.4-7.94,26.64-10.63 c0.24,6.13-0.68,12.87-1.34,19.51C105.53,36.17,98.36,38.87,91.73,42.62L91.73,42.62z M31.41,42.62l3.55-16.66 c-5.99-5.14-16.4-7.94-26.64-10.63c-0.24,6.13,0.68,12.87,1.34,19.51C17.61,36.17,24.79,38.87,31.41,42.62L31.41,42.62z M0,39.15 c2.84,32.48,23.77,52.06,58.93,57.81C57.77,56.71,30.93,45.24,0,39.15L0,39.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerSpaIcon);
export default __webpack_public_path__ + "static/media/flower-spa-icon.358eeb924189e77c5a6dd9cab797998e.svg";
export { ForwardRef as ReactComponent };